export default __webpack_public_path__ + "static/media/vedecky-ctyrboj-logo-black-en.bc9deadb.png";